import { UntypedFormGroup } from "@angular/forms";
import { AdvancedReorderModel } from "src/app/_models/advanced-reorder.model";
import { MonthlyOrderModel } from "src/app/_models/monthly-order.model";
import { SupplierModel } from "src/app/_models/supplier.model";
import { AdvancedReorderConfig } from "./advanced-reorder-config";

export class AdvancedReorderSetting extends AdvancedReorderConfig {
  subs: AdvancedReorderSubSetting[] = [];
  listings: AdvancedReorderListingSetting[] = [];
  quantity: number;
  overstockedStoresInventory?: number;
}

export class AdvancedReorderSubSetting extends AdvancedReorderConfig {
  productId: number;
  quantity: number;
}

export class AdvancedReorderListingSetting extends AdvancedReorderConfig {
  productId: number;
  storeId: number;
  asin: string;
  quantity: number;
}

export class AdvancedReorderItem {
  data: AdvancedReorderModel;
  parentId: number;
  adjSign: string;
  meSign: string;
  selected: MonthlyOrderModel[];
  totalOrderFor: number;
  orderFor?: number;
  formGroup: UntypedFormGroup;
  locationsFormGroup: UntypedFormGroup;
  storesFormGroup: UntypedFormGroup;
  overstockedStoresFormGroup: UntypedFormGroup;
  supplyTill: string;
  years: Map<number, MonthlyOrderModel[]>;
  orderForYears: Map<number, MonthlyOrderModel[]>;
  suppliers: SupplierModel[];
  shipBy: string;
  daysToArrive: number;
  ruleChanged: boolean;
  latest: MonthlyOrderModel[];
  monthly: MonthlyOrderModel[];
  focus: boolean;
  showLocation: boolean;
  avgOrders: number;
  minusAllInventory: boolean;
  minusAllStoresInventory: boolean;
  minusAllStoresOverstockedInventory: boolean;
  supplier: SupplierModel;
  storeUsedRealtime: Map<number, number>;
  overstockedStores: Map<number, number>;
  overstockedStoreInventory: number;
  usedRealtime: number;
  totalRealtime: number;
  totalReorder: number;
  orderDetails: AdvancedReorderSetting;
  hasCustomSettings: boolean;
  unsavedChanges: boolean;
  productId?: number;
  cbm?: number;
  price?: number;
  pricePlus?: number;
  adjustment?: number;
  fraction?: number;
}